// extracted by mini-css-extract-plugin
export default {"recommend":"index_recommend_22yml","recommendTitle":"index_recommendTitle_99fzt"};